import { Modal } from '../components/modal.js';

export function modal() {
    const modal = new Modal;
    modal.init('open', 'modal', 'close')
}